// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import icons from './icons';
import { Icon, getIconComponent } from '@umijs/max';
<Icon icon="ant-design:dashboard-outlined" />;
<Icon icon="ant-design:message-outlined" />;
<Icon icon="ant-design:mail-outlined" />;
<Icon icon="ant-design:book-outlined" />;
<Icon icon="ant-design:zhihu-outlined" />;
<Icon icon="ant-design:export-outlined" />;
<Icon icon="ant-design:setting-outlined" />;

function formatIcon(name: string) {
  return name
    .replace(name[0], name[0].toUpperCase())
    .replace(/-(w)/g, function(all, letter) {
      return letter.toUpperCase();
    });
}

export function patchRoutes({ routes }) {
  Object.keys(routes).forEach(key => {
    const { icon } = routes[key];
    if (icon && typeof icon === 'string') {
      const Component = getIconComponent(icon)
      if (Component) {
        routes[key].icon = <Icon icon={icon} width={14} height={14} />;
        return;
      }

      const upperIcon = formatIcon(icon);
      if (icons[upperIcon] || icons[upperIcon + 'Outlined']) {
        routes[key].icon = React.createElement(icons[upperIcon] || icons[upperIcon + 'Outlined']);
      }
    }
  });
}
